import React, { useContext, useEffect, useState } from "react";
import { Box, Paper, Snackbar, Stack, TableBody } from "@mui/material";
import { TableContainer, TableHead, TableRow } from "@mui/material";
import { IBalanco, IMesDois, IMesUm } from "../../../Interfaces/eficiencia_alimentar/cc_caderno_campo";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableCell, StyledTableHead, StyledTableHeadLeft } from "../../../Styles/tabelCellStyled/customTableCell";
import { CustomTextField, CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { TabelaMesResumo } from "./tabelas_mes_resumo";
import { del, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { Alert } from "../../../Components/Alert/Alert";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
import { Tabelanaoeditavel } from "./tabela_nao_editavel";

interface ITabelaMesProps {
  lista_tabela_editavel: IMesDois[];
  set_lista_tabela_editavel: React.Dispatch<React.SetStateAction<IMesDois[]>>;
  obj_tabela_nao_editavel: IMesUm | undefined;
  set_obj_tabela_nao_editavel: React.Dispatch<React.SetStateAction<IMesUm | undefined>>;
  obj_tabela_editavel: IMesDois | undefined;
  set_obj_tabela_editavel: React.Dispatch<React.SetStateAction<IMesDois | undefined>>;
  setCreate: React.Dispatch<React.SetStateAction<boolean>>;
  create: boolean;
  set_rows_balanco: React.Dispatch<React.SetStateAction<IBalanco | undefined>>;
  mes_escolhido: string;
  lista_tabela_nao_editavel: IMesUm[];
  set_lista_tabela_nao_editavel: React.Dispatch<React.SetStateAction<IMesUm[]>>;
  idCabecalho: number | undefined;

}

export const TabelaMes: React.FC<ITabelaMesProps> = ({
  lista_tabela_editavel,
  set_lista_tabela_editavel,
  obj_tabela_nao_editavel,
  set_obj_tabela_nao_editavel,
  obj_tabela_editavel,
  set_obj_tabela_editavel,
  setCreate,
  create,
  set_rows_balanco,
  mes_escolhido,
  lista_tabela_nao_editavel,
  set_lista_tabela_nao_editavel,
  idCabecalho
}) => {
  const auth = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);

  const [obj_tabela_editar, set_obj_tabela_editar] = useState<IMesDois>();
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [message, setMessage] = React.useState("");

  const [editRow, setEditRow] = useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);

  const message_apenas_numero = ("Apenas números são aceites");
  const [error_bovinos_M_menor_seis_Num_Animais, set_error_bovinos_M_menor_seis_Num_Animais] = useState<boolean>(false);
  const [error_bovinos_F_menor_seis_Num_Animais, set_error_bovinos_F_menor_seis_Num_Animais] = useState<boolean>(false);
  const [error_bovinos_M_seis_um_Num_Animais, set_error_bovinos_M_seis_um_Num_Animais] = useState<boolean>(false);
  const [error_bovinos_F_seis_um_Num_Animais, set_error_bovinos_F_seis_um_Num_Animais] = useState<boolean>(false);
  const [error_bovinos_M_um_dois_Num_Animais, set_error_bovinos_M_um_dois_Num_Animais] = useState<boolean>(false);
  const [error_bovinos_F_um_dois_Num_Animais, set_error_bovinos_F_um_dois_Num_Animais] = useState<boolean>(false);
  const [error_bovinos_M_maior_dois_Num_Animais, set_error_bovinos_M_maior_dois_Num_Animais] = useState<boolean>(false);
  const [error_bovinos_F_maior_dois_Num_Animais, set_error_bovinos_F_maior_dois_Num_Animais] = useState<boolean>(false);
  const [error_bovinos_M_menor_seis_Num_Dias, set_error_bovinos_M_menor_seis_Num_Dias] = useState<boolean>(false);
  const [error_bovinos_F_menor_seis_Num_Dias, set_error_bovinos_F_menor_seis_Num_Dias] = useState<boolean>(false);
  const [error_bovinos_M_seis_um_Num_Dias, set_error_bovinos_M_seis_um_Num_Dias] = useState<boolean>(false);
  const [error_bovinos_F_seis_um_Num_Dias, set_error_bovinos_F_seis_um_Num_Dias] = useState<boolean>(false);
  const [error_bovinos_M_um_dois_Num_Dias, set_error_bovinos_M_um_dois_Num_Dias] = useState<boolean>(false);
  const [error_bovinos_F_um_dois_Num_Dias, set_error_bovinos_F_um_dois_Num_Dias] = useState<boolean>(false);
  const [error_bovinos_M_maior_dois_Num_Dias, set_error_bovinos_M_maior_dois_Num_Dias] = useState<boolean>(false);
  const [error_bovinos_F_maior_dois_Num_Dias, set_error_bovinos_F_maior_dois_Num_Dias] = useState<boolean>(false);
  const [error_bovinos_M_menor_seis_Pastagem, set_error_bovinos_M_menor_seis_Pastagem] = useState<boolean>(false);
  const [error_bovinos_F_menor_seis_Pastagem, set_error_bovinos_F_menor_seis_Pastagem] = useState<boolean>(false);
  const [error_bovinos_M_seis_um_Pastagem, set_error_bovinos_M_seis_um_Pastagem] = useState<boolean>(false);
  const [error_bovinos_F_seis_um_Pastagem, set_error_bovinos_F_seis_um_Pastagem] = useState<boolean>(false);
  const [error_bovinos_M_um_dois_Pastagem, set_error_bovinos_M_um_dois_Pastagem] = useState<boolean>(false);
  const [error_bovinos_F_um_dois_Pastagem, set_error_bovinos_F_um_dois_Pastagem] = useState<boolean>(false);
  const [error_bovinos_M_maior_dois_Pastagem, set_error_bovinos_M_maior_dois_Pastagem] = useState<boolean>(false);
  const [error_bovinos_F_maior_dois_Pastagem, set_error_bovinos_F_maior_dois_Pastagem] = useState<boolean>(false);
  const [error_bovinos_M_menor_seis_Silagem, set_error_bovinos_M_menor_seis_Silagem] = useState<boolean>(false);
  const [error_bovinos_F_menor_seis_Silagem, set_error_bovinos_F_menor_seis_Silagem] = useState<boolean>(false);
  const [error_bovinos_M_seis_um_Silagem, set_error_bovinos_M_seis_um_Silagem] = useState<boolean>(false);
  const [error_bovinos_F_seis_um_Silagem, set_error_bovinos_F_seis_um_Silagem] = useState<boolean>(false);
  const [error_bovinos_M_um_dois_Silagem, set_error_bovinos_M_um_dois_Silagem] = useState<boolean>(false);
  const [error_bovinos_F_um_dois_Silagem, set_error_bovinos_F_um_dois_Silagem] = useState<boolean>(false);
  const [error_bovinos_M_maior_dois_Silagem, set_error_bovinos_M_maior_dois_Silagem] = useState<boolean>(false);
  const [error_bovinos_F_maior_dois_Silagem, set_error_bovinos_F_maior_dois_Silagem] = useState<boolean>(false);
  const [error_bovinos_M_menor_seis_outra_ferragem, set_error_bovinos_M_menor_seis_outra_ferragem] = useState<boolean>(false);
  const [error_bovinos_F_menor_seis_outra_ferragem, set_error_bovinos_F_menor_seis_outra_ferragem] = useState<boolean>(false);
  const [error_bovinos_M_seis_um_outra_ferragem, set_error_bovinos_M_seis_um_outra_ferragem] = useState<boolean>(false);
  const [error_bovinos_F_seis_um_outra_ferragem, set_error_bovinos_F_seis_um_outra_ferragem] = useState<boolean>(false);
  const [error_bovinos_M_um_dois_outra_ferragem, set_error_bovinos_M_um_dois_outra_ferragem] = useState<boolean>(false);
  const [error_bovinos_F_um_dois_outra_ferragem, set_error_bovinos_F_um_dois_outra_ferragem] = useState<boolean>(false);
  const [error_bovinos_M_maior_dois_outra_ferragem, set_error_bovinos_M_maior_dois_outra_ferragem] = useState<boolean>(false);
  const [error_bovinos_F_maior_dois_outra_ferragem, set_error_bovinos_F_maior_dois_outra_ferragem] = useState<boolean>(false);
  const [error_bovinos_M_menor_seis_Composto, set_error_bovinos_M_menor_seis_Composto] = useState<boolean>(false);
  const [error_bovinos_F_menor_seis_Composto, set_error_bovinos_F_menor_seis_Composto] = useState<boolean>(false);
  const [error_bovinos_M_seis_um_Composto, set_error_bovinos_M_seis_um_Composto] = useState<boolean>(false);
  const [error_bovinos_F_seis_um_Composto, set_error_bovinos_F_seis_um_Composto] = useState<boolean>(false);
  const [error_bovinos_M_um_dois_Composto, set_error_bovinos_M_um_dois_Composto] = useState<boolean>(false);
  const [error_bovinos_F_um_dois_Composto, set_error_bovinos_F_um_dois_Composto] = useState<boolean>(false);
  const [error_bovinos_M_maior_dois_Composto, set_error_bovinos_M_maior_dois_Composto] = useState<boolean>(false);
  const [error_bovinos_F_maior_dois_Composto, set_error_bovinos_F_maior_dois_Composto] = useState<boolean>(false);


  const func_reset = () => {
    set_obj_tabela_editar(undefined)
    setEditRow(false)
    setOpenDelete(false)
    set_error_bovinos_M_menor_seis_Num_Animais(false)
    set_error_bovinos_F_menor_seis_Num_Animais(false)
    set_error_bovinos_M_seis_um_Num_Animais(false)
    set_error_bovinos_F_seis_um_Num_Animais(false)
    set_error_bovinos_M_um_dois_Num_Animais(false)
    set_error_bovinos_F_um_dois_Num_Animais(false)
    set_error_bovinos_M_maior_dois_Num_Animais(false)
    set_error_bovinos_F_maior_dois_Num_Animais(false)
    set_error_bovinos_M_menor_seis_Num_Dias(false)
    set_error_bovinos_F_menor_seis_Num_Dias(false)
    set_error_bovinos_M_seis_um_Num_Dias(false)
    set_error_bovinos_F_seis_um_Num_Dias(false)
    set_error_bovinos_M_um_dois_Num_Dias(false)
    set_error_bovinos_F_um_dois_Num_Dias(false)
    set_error_bovinos_M_maior_dois_Num_Dias(false)
    set_error_bovinos_F_maior_dois_Num_Dias(false)
    set_error_bovinos_M_menor_seis_Pastagem(false)
    set_error_bovinos_F_menor_seis_Pastagem(false)
    set_error_bovinos_M_seis_um_Pastagem(false)
    set_error_bovinos_F_seis_um_Pastagem(false)
    set_error_bovinos_M_um_dois_Pastagem(false)
    set_error_bovinos_F_um_dois_Pastagem(false)
    set_error_bovinos_F_maior_dois_Pastagem(false)
    set_error_bovinos_M_menor_seis_Silagem(false)
    set_error_bovinos_F_menor_seis_Silagem(false)
    set_error_bovinos_M_seis_um_Silagem(false)
    set_error_bovinos_F_seis_um_Silagem(false)
    set_error_bovinos_M_um_dois_Silagem(false)
    set_error_bovinos_F_um_dois_Silagem(false)
    set_error_bovinos_M_maior_dois_Silagem(false)
    set_error_bovinos_F_maior_dois_Silagem(false)
    set_error_bovinos_M_menor_seis_outra_ferragem(false)
    set_error_bovinos_F_menor_seis_outra_ferragem(false)
    set_error_bovinos_M_seis_um_outra_ferragem(false)
    set_error_bovinos_F_seis_um_outra_ferragem(false)
    set_error_bovinos_M_um_dois_outra_ferragem(false)
    set_error_bovinos_F_um_dois_outra_ferragem(false)
    set_error_bovinos_M_maior_dois_outra_ferragem(false)
    set_error_bovinos_F_maior_dois_outra_ferragem(false)
    set_error_bovinos_M_menor_seis_Composto(false)
    set_error_bovinos_F_menor_seis_Composto(false)
    set_error_bovinos_M_seis_um_Composto(false)
    set_error_bovinos_F_seis_um_Composto(false)
    set_error_bovinos_M_um_dois_Composto(false)
    set_error_bovinos_F_um_dois_Composto(false)
    set_error_bovinos_M_maior_dois_Composto(false)
    set_error_bovinos_F_maior_dois_Composto(false)

  }


  const handleCancel = () => {
    setCreate(false);
    set_obj_tabela_editar(undefined);
    setEditRow(false);
  }

  const onInputChange = (event: any) => {
    const { name, value, } = event.target;
    if (name === 'bovinos_M_menor_seis_Num_Animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_menor_seis_Num_Animais(true)
      } else {
        set_error_bovinos_M_menor_seis_Num_Animais(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_menor_seis_Num_Animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_menor_seis_Num_Animais(true)
      } else {
        set_error_bovinos_F_menor_seis_Num_Animais(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_seis_um_Num_Animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_seis_um_Num_Animais(true)
      } else {
        set_error_bovinos_M_seis_um_Num_Animais(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_seis_um_Num_Animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_seis_um_Num_Animais(true)
      } else {
        set_error_bovinos_F_seis_um_Num_Animais(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_seis_um_Num_Animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_seis_um_Num_Animais(true)
      } else {
        set_error_bovinos_F_seis_um_Num_Animais(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_um_dois_Num_Animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_um_dois_Num_Animais(true)
      } else {
        set_error_bovinos_M_um_dois_Num_Animais(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_um_dois_Num_Animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_um_dois_Num_Animais(true)
      } else {
        set_error_bovinos_F_um_dois_Num_Animais(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_maior_dois_Num_Animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_maior_dois_Num_Animais(true)
      } else {
        set_error_bovinos_M_maior_dois_Num_Animais(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_maior_dois_Num_Animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_maior_dois_Num_Animais(true)
      } else {
        set_error_bovinos_F_maior_dois_Num_Animais(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_menor_seis_Num_Dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_menor_seis_Num_Dias(true)
      } else {
        set_error_bovinos_M_menor_seis_Num_Dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_menor_seis_Num_Dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_menor_seis_Num_Dias(true)
      } else {
        set_error_bovinos_F_menor_seis_Num_Dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_seis_um_Num_Dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_seis_um_Num_Dias(true)
      } else {
        set_error_bovinos_M_seis_um_Num_Dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_seis_um_Num_Dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_seis_um_Num_Dias(true)
      } else {
        set_error_bovinos_F_seis_um_Num_Dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_um_dois_Num_Dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_um_dois_Num_Dias(true)
      } else {
        set_error_bovinos_M_um_dois_Num_Dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_um_dois_Num_Dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_um_dois_Num_Dias(true)
      } else {
        set_error_bovinos_F_um_dois_Num_Dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_maior_dois_Num_Dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_maior_dois_Num_Dias(true)
      } else {
        set_error_bovinos_M_maior_dois_Num_Dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_maior_dois_Num_Dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_maior_dois_Num_Dias(true)
      } else {
        set_error_bovinos_F_maior_dois_Num_Dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_menor_seis_Pastagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_menor_seis_Pastagem(true)
      } else {
        set_error_bovinos_M_menor_seis_Pastagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_menor_seis_Pastagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_menor_seis_Pastagem(true)
      } else {
        set_error_bovinos_F_menor_seis_Pastagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_seis_um_Pastagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_seis_um_Pastagem(true)
      } else {
        set_error_bovinos_M_seis_um_Pastagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_seis_um_Pastagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_seis_um_Pastagem(true)
      } else {
        set_error_bovinos_F_seis_um_Pastagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_um_dois_Pastagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_um_dois_Pastagem(true)
      } else {
        set_error_bovinos_M_um_dois_Pastagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_um_dois_Pastagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_um_dois_Pastagem(true)
      } else {
        set_error_bovinos_F_um_dois_Pastagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_maior_dois_Pastagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_maior_dois_Pastagem(true)
      } else {
        set_error_bovinos_M_maior_dois_Pastagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_maior_dois_Pastagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_maior_dois_Pastagem(true)
      } else {
        set_error_bovinos_F_maior_dois_Pastagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_menor_seis_Silagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_menor_seis_Silagem(true)
      } else {
        set_error_bovinos_M_menor_seis_Silagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_menor_seis_Silagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_menor_seis_Silagem(true)
      } else {
        set_error_bovinos_F_menor_seis_Silagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_seis_um_Silagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_seis_um_Silagem(true)
      } else {
        set_error_bovinos_M_seis_um_Silagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_seis_um_Silagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_seis_um_Silagem(true)
      } else {
        set_error_bovinos_F_seis_um_Silagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_um_dois_Silagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_um_dois_Silagem(true)
      } else {
        set_error_bovinos_M_um_dois_Silagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_um_dois_Silagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_um_dois_Silagem(true)
      } else {
        set_error_bovinos_F_um_dois_Silagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_maior_dois_Silagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_maior_dois_Silagem(true)
      } else {
        set_error_bovinos_M_maior_dois_Silagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_maior_dois_Silagem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_maior_dois_Silagem(true)
      } else {
        set_error_bovinos_F_maior_dois_Silagem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_menor_seis_outra_ferragem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_menor_seis_outra_ferragem(true)
      } else {
        set_error_bovinos_M_menor_seis_outra_ferragem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_menor_seis_outra_ferragem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_menor_seis_outra_ferragem(true)
      } else {
        set_error_bovinos_F_menor_seis_outra_ferragem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_seis_um_outra_ferragem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_seis_um_outra_ferragem(true)
      } else {
        set_error_bovinos_M_seis_um_outra_ferragem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_seis_um_outra_ferragem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_seis_um_outra_ferragem(true)
      } else {
        set_error_bovinos_F_seis_um_outra_ferragem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_um_dois_outra_ferragem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_um_dois_outra_ferragem(true)
      } else {
        set_error_bovinos_M_um_dois_outra_ferragem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_um_dois_outra_ferragem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_um_dois_outra_ferragem(true)
      } else {
        set_error_bovinos_F_um_dois_outra_ferragem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_maior_dois_outra_ferragem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_maior_dois_outra_ferragem(true)
      } else {
        set_error_bovinos_M_maior_dois_outra_ferragem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_maior_dois_outra_ferragem') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_maior_dois_outra_ferragem(true)
      } else {
        set_error_bovinos_F_maior_dois_outra_ferragem(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_menor_seis_Composto') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_menor_seis_Composto(true)
      } else {
        set_error_bovinos_M_menor_seis_Composto(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_menor_seis_Composto') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_menor_seis_Composto(true)
      } else {
        set_error_bovinos_F_menor_seis_Composto(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_seis_um_Composto') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_seis_um_Composto(true)
      } else {
        set_error_bovinos_M_seis_um_Composto(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_seis_um_Composto') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_seis_um_Composto(true)
      } else {
        set_error_bovinos_F_seis_um_Composto(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_um_dois_Composto') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_um_dois_Composto(true)
      } else {
        set_error_bovinos_M_um_dois_Composto(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_um_dois_Composto') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_um_dois_Composto(true)
      } else {
        set_error_bovinos_F_um_dois_Composto(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_M_maior_dois_Composto') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_M_maior_dois_Composto(true)
      } else {
        set_error_bovinos_M_maior_dois_Composto(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'bovinos_F_maior_dois_Composto') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_bovinos_F_maior_dois_Composto(true)
      } else {
        set_error_bovinos_F_maior_dois_Composto(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else {

      set_obj_tabela_editar((prev: any) => ({
        ...prev,
        [name]: value,
      }));

    }




  };


  const handleSaveTabela = async () => {
    if (obj_tabela_editar === undefined) {

      setMessage("Preencha a tabela antes de gravar1!");
      setOpenSnackError(true);
    } else
      try {
        let res = await post(auth.token.cookie_token, "new__balanco_mes_tab_dois", {
          payload: {
            id_mes_tab_dois: 0,
            bovinos_M_menor_seis_Num_Animais: obj_tabela_editar.bovinos_M_menor_seis_Num_Animais === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_M_menor_seis_Num_Animais.toString().length === 0 ? 0 : Number(obj_tabela_editar.bovinos_M_menor_seis_Num_Animais),
            bovinos_F_menor_seis_Num_Animais: obj_tabela_editar.bovinos_F_menor_seis_Num_Animais === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_F_menor_seis_Num_Animais.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_menor_seis_Num_Animais,
            bovinos_M_seis_um_Num_Animais: obj_tabela_editar.bovinos_M_seis_um_Num_Animais === undefined || obj_tabela_editar?.bovinos_M_seis_um_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_M_seis_um_Num_Animais.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_seis_um_Num_Animais,
            bovinos_F_seis_um_Num_Animais: obj_tabela_editar.bovinos_F_seis_um_Num_Animais === undefined || obj_tabela_editar?.bovinos_F_seis_um_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_F_seis_um_Num_Animais.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_seis_um_Num_Animais,
            bovinos_M_um_dois_Num_Animais: obj_tabela_editar.bovinos_M_um_dois_Num_Animais === undefined || obj_tabela_editar?.bovinos_M_um_dois_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_M_um_dois_Num_Animais.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_um_dois_Num_Animais,
            bovinos_F_um_dois_Num_Animais: obj_tabela_editar.bovinos_F_um_dois_Num_Animais === undefined || obj_tabela_editar?.bovinos_F_um_dois_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_F_um_dois_Num_Animais.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_um_dois_Num_Animais,
            bovinos_M_maior_dois_Num_Animais: obj_tabela_editar.bovinos_M_maior_dois_Num_Animais === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_M_maior_dois_Num_Animais.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_maior_dois_Num_Animais,
            bovinos_F_maior_dois_Num_Animais: obj_tabela_editar.bovinos_F_maior_dois_Num_Animais === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_F_maior_dois_Num_Animais.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_maior_dois_Num_Animais,
            bovinos_M_menor_seis_Num_Dias: obj_tabela_editar.bovinos_M_menor_seis_Num_Dias === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_M_menor_seis_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_menor_seis_Num_Dias,
            bovinos_F_menor_seis_Num_Dias: obj_tabela_editar.bovinos_F_menor_seis_Num_Dias === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_F_menor_seis_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_menor_seis_Num_Dias,
            bovinos_M_seis_um_Num_Dias: obj_tabela_editar.bovinos_M_seis_um_Num_Dias === undefined || obj_tabela_editar?.bovinos_M_seis_um_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_M_seis_um_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_seis_um_Num_Dias,
            bovinos_F_seis_um_Num_Dias: obj_tabela_editar.bovinos_F_seis_um_Num_Dias === undefined || obj_tabela_editar?.bovinos_F_seis_um_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_F_seis_um_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_seis_um_Num_Dias,
            bovinos_M_um_dois_Num_Dias: obj_tabela_editar.bovinos_M_um_dois_Num_Dias === undefined || obj_tabela_editar?.bovinos_M_um_dois_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_M_um_dois_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_um_dois_Num_Dias,
            bovinos_F_um_dois_Num_Dias: obj_tabela_editar.bovinos_F_um_dois_Num_Dias === undefined || obj_tabela_editar?.bovinos_F_um_dois_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_F_um_dois_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_um_dois_Num_Dias,
            bovinos_M_maior_dois_Num_Dias: obj_tabela_editar.bovinos_M_maior_dois_Num_Dias === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_M_maior_dois_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_maior_dois_Num_Dias,
            bovinos_F_maior_dois_Num_Dias: obj_tabela_editar.bovinos_F_maior_dois_Num_Dias === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_F_maior_dois_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_maior_dois_Num_Dias,
            bovinos_M_menor_seis_Pastagem: obj_tabela_editar.bovinos_M_menor_seis_Pastagem === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_M_menor_seis_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_menor_seis_Pastagem,
            bovinos_F_menor_seis_Pastagem: obj_tabela_editar.bovinos_F_menor_seis_Pastagem === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_F_menor_seis_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_menor_seis_Pastagem,
            bovinos_M_seis_um_Pastagem: obj_tabela_editar.bovinos_M_seis_um_Pastagem === undefined || obj_tabela_editar?.bovinos_M_seis_um_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_M_seis_um_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_seis_um_Pastagem,
            bovinos_F_seis_um_Pastagem: obj_tabela_editar.bovinos_F_seis_um_Pastagem === undefined || obj_tabela_editar?.bovinos_F_seis_um_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_F_seis_um_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_seis_um_Pastagem,
            bovinos_M_um_dois_Pastagem: obj_tabela_editar.bovinos_M_um_dois_Pastagem === undefined || obj_tabela_editar?.bovinos_M_um_dois_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_M_um_dois_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_um_dois_Pastagem,
            bovinos_F_um_dois_Pastagem: obj_tabela_editar.bovinos_F_um_dois_Pastagem === undefined || obj_tabela_editar?.bovinos_F_um_dois_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_F_um_dois_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_um_dois_Pastagem,
            bovinos_M_maior_dois_Pastagem: obj_tabela_editar.bovinos_M_maior_dois_Pastagem === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_M_maior_dois_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_maior_dois_Pastagem,
            bovinos_F_maior_dois_Pastagem: obj_tabela_editar.bovinos_F_maior_dois_Pastagem === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_F_maior_dois_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_maior_dois_Pastagem,
            bovinos_M_menor_seis_Silagem: obj_tabela_editar.bovinos_M_menor_seis_Silagem === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Silagem === null ? 0 : obj_tabela_editar?.bovinos_M_menor_seis_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_menor_seis_Silagem,
            bovinos_F_menor_seis_Silagem: obj_tabela_editar.bovinos_F_menor_seis_Silagem === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Silagem === null ? 0 : obj_tabela_editar?.bovinos_F_menor_seis_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_menor_seis_Silagem,
            bovinos_M_seis_um_Silagem: obj_tabela_editar.bovinos_M_seis_um_Silagem === undefined || obj_tabela_editar?.bovinos_M_seis_um_Silagem === null ? 0 : obj_tabela_editar?.bovinos_M_seis_um_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_seis_um_Silagem,
            bovinos_F_seis_um_Silagem: obj_tabela_editar.bovinos_F_seis_um_Silagem === undefined || obj_tabela_editar?.bovinos_F_seis_um_Silagem === null ? 0 : obj_tabela_editar?.bovinos_F_seis_um_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_seis_um_Silagem,
            bovinos_M_um_dois_Silagem: obj_tabela_editar.bovinos_M_um_dois_Silagem === undefined || obj_tabela_editar?.bovinos_M_um_dois_Silagem === null ? 0 : obj_tabela_editar?.bovinos_M_um_dois_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_um_dois_Silagem,
            bovinos_F_um_dois_Silagem: obj_tabela_editar.bovinos_F_um_dois_Silagem === undefined || obj_tabela_editar?.bovinos_F_um_dois_Silagem === null ? 0 : obj_tabela_editar?.bovinos_F_um_dois_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_um_dois_Silagem,
            bovinos_M_maior_dois_Silagem: obj_tabela_editar.bovinos_M_maior_dois_Silagem === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Silagem === null ? 0 : obj_tabela_editar?.bovinos_M_maior_dois_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_maior_dois_Silagem,
            bovinos_F_maior_dois_Silagem: obj_tabela_editar.bovinos_F_maior_dois_Silagem === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Silagem === null ? 0 : obj_tabela_editar?.bovinos_F_maior_dois_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_maior_dois_Silagem,
            bovinos_M_menor_seis_outra_ferragem: obj_tabela_editar.bovinos_M_menor_seis_outra_ferragem === undefined || obj_tabela_editar?.bovinos_M_menor_seis_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_M_menor_seis_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_menor_seis_outra_ferragem,
            bovinos_F_menor_seis_outra_ferragem: obj_tabela_editar.bovinos_F_menor_seis_outra_ferragem === undefined || obj_tabela_editar?.bovinos_F_menor_seis_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_F_menor_seis_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_menor_seis_outra_ferragem,
            bovinos_M_seis_um_outra_ferragem: obj_tabela_editar.bovinos_M_seis_um_outra_ferragem === undefined || obj_tabela_editar?.bovinos_M_seis_um_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_M_seis_um_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_seis_um_outra_ferragem,
            bovinos_F_seis_um_outra_ferragem: obj_tabela_editar.bovinos_F_seis_um_outra_ferragem === undefined || obj_tabela_editar?.bovinos_F_seis_um_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_F_seis_um_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_seis_um_outra_ferragem,
            bovinos_M_um_dois_outra_ferragem: obj_tabela_editar.bovinos_M_um_dois_outra_ferragem === undefined || obj_tabela_editar?.bovinos_M_um_dois_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_M_um_dois_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_um_dois_outra_ferragem,
            bovinos_F_um_dois_outra_ferragem: obj_tabela_editar.bovinos_F_um_dois_outra_ferragem === undefined || obj_tabela_editar?.bovinos_F_um_dois_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_F_um_dois_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_um_dois_outra_ferragem,
            bovinos_M_maior_dois_outra_ferragem: obj_tabela_editar.bovinos_M_maior_dois_outra_ferragem === undefined || obj_tabela_editar?.bovinos_M_maior_dois_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_M_maior_dois_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_maior_dois_outra_ferragem,
            bovinos_F_maior_dois_outra_ferragem: obj_tabela_editar.bovinos_F_maior_dois_outra_ferragem === undefined || obj_tabela_editar?.bovinos_F_maior_dois_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_F_maior_dois_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_maior_dois_outra_ferragem,
            bovinos_M_menor_seis_Composto: obj_tabela_editar.bovinos_M_menor_seis_Composto === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Composto === null ? 0 : obj_tabela_editar?.bovinos_M_menor_seis_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_menor_seis_Composto,
            bovinos_F_menor_seis_Composto: obj_tabela_editar.bovinos_F_menor_seis_Composto === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Composto === null ? 0 : obj_tabela_editar?.bovinos_F_menor_seis_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_menor_seis_Composto,
            bovinos_M_seis_um_Composto: obj_tabela_editar.bovinos_M_seis_um_Composto === undefined || obj_tabela_editar?.bovinos_M_seis_um_Composto === null ? 0 : obj_tabela_editar?.bovinos_M_seis_um_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_seis_um_Composto,
            bovinos_F_seis_um_Composto: obj_tabela_editar.bovinos_F_seis_um_Composto === undefined || obj_tabela_editar?.bovinos_F_seis_um_Composto === null ? 0 : obj_tabela_editar?.bovinos_F_seis_um_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_seis_um_Composto,
            bovinos_M_um_dois_Composto: obj_tabela_editar.bovinos_M_um_dois_Composto === undefined || obj_tabela_editar?.bovinos_M_um_dois_Composto === null ? 0 : obj_tabela_editar?.bovinos_M_um_dois_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_um_dois_Composto,
            bovinos_F_um_dois_Composto: obj_tabela_editar.bovinos_F_um_dois_Composto === undefined || obj_tabela_editar?.bovinos_F_um_dois_Composto === null ? 0 : obj_tabela_editar?.bovinos_F_um_dois_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_um_dois_Composto,
            bovinos_M_maior_dois_Composto: obj_tabela_editar.bovinos_M_maior_dois_Composto === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Composto === null ? 0 : obj_tabela_editar?.bovinos_M_maior_dois_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_maior_dois_Composto,
            bovinos_F_maior_dois_Composto: obj_tabela_editar.bovinos_F_maior_dois_Composto === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Composto === null ? 0 : obj_tabela_editar?.bovinos_F_maior_dois_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_maior_dois_Composto,
            id_mes_tab_um: obj_tabela_nao_editavel?.id_mes_tab_um,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });
        if (res.status === 200) {
          setMessage("Gravado com sucesso!");

          set_obj_tabela_editavel(res.data.result[0]);
          set_obj_tabela_editar(res.data.result[1][0]);
          set_rows_balanco(res.data.result[2][0])

          if (lista_tabela_editavel === undefined || lista_tabela_editavel.length === 0) {
            set_lista_tabela_editavel([res.data.result[0]])
          } else {
            set_lista_tabela_editavel((prev) => [
              ...prev,
              res.data.result[0]
            ])
          }

          handleCancel()
          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print("handleSaveTabela", error, true);
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
        setIsLoading(false);
      }
  }

  const handleUpdatetabela = async () => {
    if (obj_tabela_editar === undefined
    ) {
      setMessage("Preencha a tabela antes de gravar!");
      setOpenSnackError(true);
    } else
      try {
        setIsLoading(true);
        let res = await post(auth.token.cookie_token, `update_mes_tab_dois`, {
          payload: {
            id_mes_tab_dois: obj_tabela_editar.id_mes_tab_dois,
            bovinos_M_menor_seis_Num_Animais: obj_tabela_editar.bovinos_M_menor_seis_Num_Animais === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_M_menor_seis_Num_Animais.toString().length === 0 ? 0 : Number(obj_tabela_editar.bovinos_M_menor_seis_Num_Animais),
            bovinos_F_menor_seis_Num_Animais: obj_tabela_editar.bovinos_F_menor_seis_Num_Animais === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_F_menor_seis_Num_Animais.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_menor_seis_Num_Animais,
            bovinos_M_seis_um_Num_Animais: obj_tabela_editar.bovinos_M_seis_um_Num_Animais === undefined || obj_tabela_editar?.bovinos_M_seis_um_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_M_seis_um_Num_Animais.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_seis_um_Num_Animais,
            bovinos_F_seis_um_Num_Animais: obj_tabela_editar.bovinos_F_seis_um_Num_Animais === undefined || obj_tabela_editar?.bovinos_F_seis_um_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_F_seis_um_Num_Animais.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_seis_um_Num_Animais,
            bovinos_M_um_dois_Num_Animais: obj_tabela_editar.bovinos_M_um_dois_Num_Animais === undefined || obj_tabela_editar?.bovinos_M_um_dois_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_M_um_dois_Num_Animais.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_um_dois_Num_Animais,
            bovinos_F_um_dois_Num_Animais: obj_tabela_editar.bovinos_F_um_dois_Num_Animais === undefined || obj_tabela_editar?.bovinos_F_um_dois_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_F_um_dois_Num_Animais.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_um_dois_Num_Animais,
            bovinos_M_maior_dois_Num_Animais: obj_tabela_editar.bovinos_M_maior_dois_Num_Animais === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_M_maior_dois_Num_Animais.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_maior_dois_Num_Animais,
            bovinos_F_maior_dois_Num_Animais: obj_tabela_editar.bovinos_F_maior_dois_Num_Animais === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Num_Animais === null ? 0 : obj_tabela_editar?.bovinos_F_maior_dois_Num_Animais.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_maior_dois_Num_Animais,
            bovinos_M_menor_seis_Num_Dias: obj_tabela_editar.bovinos_M_menor_seis_Num_Dias === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_M_menor_seis_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_menor_seis_Num_Dias,
            bovinos_F_menor_seis_Num_Dias: obj_tabela_editar.bovinos_F_menor_seis_Num_Dias === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_F_menor_seis_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_menor_seis_Num_Dias,
            bovinos_M_seis_um_Num_Dias: obj_tabela_editar.bovinos_M_seis_um_Num_Dias === undefined || obj_tabela_editar?.bovinos_M_seis_um_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_M_seis_um_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_seis_um_Num_Dias,
            bovinos_F_seis_um_Num_Dias: obj_tabela_editar.bovinos_F_seis_um_Num_Dias === undefined || obj_tabela_editar?.bovinos_F_seis_um_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_F_seis_um_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_seis_um_Num_Dias,
            bovinos_M_um_dois_Num_Dias: obj_tabela_editar.bovinos_M_um_dois_Num_Dias === undefined || obj_tabela_editar?.bovinos_M_um_dois_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_M_um_dois_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_um_dois_Num_Dias,
            bovinos_F_um_dois_Num_Dias: obj_tabela_editar.bovinos_F_um_dois_Num_Dias === undefined || obj_tabela_editar?.bovinos_F_um_dois_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_F_um_dois_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_um_dois_Num_Dias,
            bovinos_M_maior_dois_Num_Dias: obj_tabela_editar.bovinos_M_maior_dois_Num_Dias === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_M_maior_dois_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_maior_dois_Num_Dias,
            bovinos_F_maior_dois_Num_Dias: obj_tabela_editar.bovinos_F_maior_dois_Num_Dias === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Num_Dias === null ? 0 : obj_tabela_editar?.bovinos_F_maior_dois_Num_Dias.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_maior_dois_Num_Dias,
            bovinos_M_menor_seis_Pastagem: obj_tabela_editar.bovinos_M_menor_seis_Pastagem === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_M_menor_seis_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_menor_seis_Pastagem,
            bovinos_F_menor_seis_Pastagem: obj_tabela_editar.bovinos_F_menor_seis_Pastagem === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_F_menor_seis_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_menor_seis_Pastagem,
            bovinos_M_seis_um_Pastagem: obj_tabela_editar.bovinos_M_seis_um_Pastagem === undefined || obj_tabela_editar?.bovinos_M_seis_um_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_M_seis_um_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_seis_um_Pastagem,
            bovinos_F_seis_um_Pastagem: obj_tabela_editar.bovinos_F_seis_um_Pastagem === undefined || obj_tabela_editar?.bovinos_F_seis_um_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_F_seis_um_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_seis_um_Pastagem,
            bovinos_M_um_dois_Pastagem: obj_tabela_editar.bovinos_M_um_dois_Pastagem === undefined || obj_tabela_editar?.bovinos_M_um_dois_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_M_um_dois_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_um_dois_Pastagem,
            bovinos_F_um_dois_Pastagem: obj_tabela_editar.bovinos_F_um_dois_Pastagem === undefined || obj_tabela_editar?.bovinos_F_um_dois_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_F_um_dois_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_um_dois_Pastagem,
            bovinos_M_maior_dois_Pastagem: obj_tabela_editar.bovinos_M_maior_dois_Pastagem === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_M_maior_dois_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_maior_dois_Pastagem,
            bovinos_F_maior_dois_Pastagem: obj_tabela_editar.bovinos_F_maior_dois_Pastagem === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Pastagem === null ? 0 : obj_tabela_editar?.bovinos_F_maior_dois_Pastagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_maior_dois_Pastagem,
            bovinos_M_menor_seis_Silagem: obj_tabela_editar.bovinos_M_menor_seis_Silagem === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Silagem === null ? 0 : obj_tabela_editar?.bovinos_M_menor_seis_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_menor_seis_Silagem,
            bovinos_F_menor_seis_Silagem: obj_tabela_editar.bovinos_F_menor_seis_Silagem === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Silagem === null ? 0 : obj_tabela_editar?.bovinos_F_menor_seis_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_menor_seis_Silagem,
            bovinos_M_seis_um_Silagem: obj_tabela_editar.bovinos_M_seis_um_Silagem === undefined || obj_tabela_editar?.bovinos_M_seis_um_Silagem === null ? 0 : obj_tabela_editar?.bovinos_M_seis_um_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_seis_um_Silagem,
            bovinos_F_seis_um_Silagem: obj_tabela_editar.bovinos_F_seis_um_Silagem === undefined || obj_tabela_editar?.bovinos_F_seis_um_Silagem === null ? 0 : obj_tabela_editar?.bovinos_F_seis_um_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_seis_um_Silagem,
            bovinos_M_um_dois_Silagem: obj_tabela_editar.bovinos_M_um_dois_Silagem === undefined || obj_tabela_editar?.bovinos_M_um_dois_Silagem === null ? 0 : obj_tabela_editar?.bovinos_M_um_dois_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_um_dois_Silagem,
            bovinos_F_um_dois_Silagem: obj_tabela_editar.bovinos_F_um_dois_Silagem === undefined || obj_tabela_editar?.bovinos_F_um_dois_Silagem === null ? 0 : obj_tabela_editar?.bovinos_F_um_dois_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_um_dois_Silagem,
            bovinos_M_maior_dois_Silagem: obj_tabela_editar.bovinos_M_maior_dois_Silagem === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Silagem === null ? 0 : obj_tabela_editar?.bovinos_M_maior_dois_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_maior_dois_Silagem,
            bovinos_F_maior_dois_Silagem: obj_tabela_editar.bovinos_F_maior_dois_Silagem === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Silagem === null ? 0 : obj_tabela_editar?.bovinos_F_maior_dois_Silagem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_maior_dois_Silagem,
            bovinos_M_menor_seis_outra_ferragem: obj_tabela_editar.bovinos_M_menor_seis_outra_ferragem === undefined || obj_tabela_editar?.bovinos_M_menor_seis_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_M_menor_seis_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_menor_seis_outra_ferragem,
            bovinos_F_menor_seis_outra_ferragem: obj_tabela_editar.bovinos_F_menor_seis_outra_ferragem === undefined || obj_tabela_editar?.bovinos_F_menor_seis_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_F_menor_seis_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_menor_seis_outra_ferragem,
            bovinos_M_seis_um_outra_ferragem: obj_tabela_editar.bovinos_M_seis_um_outra_ferragem === undefined || obj_tabela_editar?.bovinos_M_seis_um_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_M_seis_um_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_seis_um_outra_ferragem,
            bovinos_F_seis_um_outra_ferragem: obj_tabela_editar.bovinos_F_seis_um_outra_ferragem === undefined || obj_tabela_editar?.bovinos_F_seis_um_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_F_seis_um_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_seis_um_outra_ferragem,
            bovinos_M_um_dois_outra_ferragem: obj_tabela_editar.bovinos_M_um_dois_outra_ferragem === undefined || obj_tabela_editar?.bovinos_M_um_dois_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_M_um_dois_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_um_dois_outra_ferragem,
            bovinos_F_um_dois_outra_ferragem: obj_tabela_editar.bovinos_F_um_dois_outra_ferragem === undefined || obj_tabela_editar?.bovinos_F_um_dois_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_F_um_dois_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_um_dois_outra_ferragem,
            bovinos_M_maior_dois_outra_ferragem: obj_tabela_editar.bovinos_M_maior_dois_outra_ferragem === undefined || obj_tabela_editar?.bovinos_M_maior_dois_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_M_maior_dois_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_maior_dois_outra_ferragem,
            bovinos_F_maior_dois_outra_ferragem: obj_tabela_editar.bovinos_F_maior_dois_outra_ferragem === undefined || obj_tabela_editar?.bovinos_F_maior_dois_outra_ferragem === null ? 0 : obj_tabela_editar?.bovinos_F_maior_dois_outra_ferragem.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_maior_dois_outra_ferragem,
            bovinos_M_menor_seis_Composto: obj_tabela_editar.bovinos_M_menor_seis_Composto === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Composto === null ? 0 : obj_tabela_editar?.bovinos_M_menor_seis_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_menor_seis_Composto,
            bovinos_F_menor_seis_Composto: obj_tabela_editar.bovinos_F_menor_seis_Composto === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Composto === null ? 0 : obj_tabela_editar?.bovinos_F_menor_seis_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_menor_seis_Composto,
            bovinos_M_seis_um_Composto: obj_tabela_editar.bovinos_M_seis_um_Composto === undefined || obj_tabela_editar?.bovinos_M_seis_um_Composto === null ? 0 : obj_tabela_editar?.bovinos_M_seis_um_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_seis_um_Composto,
            bovinos_F_seis_um_Composto: obj_tabela_editar.bovinos_F_seis_um_Composto === undefined || obj_tabela_editar?.bovinos_F_seis_um_Composto === null ? 0 : obj_tabela_editar?.bovinos_F_seis_um_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_seis_um_Composto,
            bovinos_M_um_dois_Composto: obj_tabela_editar.bovinos_M_um_dois_Composto === undefined || obj_tabela_editar?.bovinos_M_um_dois_Composto === null ? 0 : obj_tabela_editar?.bovinos_M_um_dois_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_um_dois_Composto,
            bovinos_F_um_dois_Composto: obj_tabela_editar.bovinos_F_um_dois_Composto === undefined || obj_tabela_editar?.bovinos_F_um_dois_Composto === null ? 0 : obj_tabela_editar?.bovinos_F_um_dois_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_um_dois_Composto,
            bovinos_M_maior_dois_Composto: obj_tabela_editar.bovinos_M_maior_dois_Composto === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Composto === null ? 0 : obj_tabela_editar?.bovinos_M_maior_dois_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_M_maior_dois_Composto,
            bovinos_F_maior_dois_Composto: obj_tabela_editar.bovinos_F_maior_dois_Composto === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Composto === null ? 0 : obj_tabela_editar?.bovinos_F_maior_dois_Composto.toString().length === 0 ? 0 : obj_tabela_editar.bovinos_F_maior_dois_Composto,
            id_mes_tab_um: obj_tabela_editar.id_mes_tab_um,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });

        if (res.status === 200) {
          setMessage("Registado com sucesso!");

          set_obj_tabela_editavel(res.data.result[0]);
          set_obj_tabela_editar(res.data.result[1][0]);
          set_rows_balanco(res.data.result[2][0])

          let aux = lista_tabela_editavel.map((el) => {
            if (el.id_mes_tab_dois !== res.data.result[0].id_mes_tab_dois) {
              return el
            } else {
              return res.data.result[0]
            }

          })
          set_lista_tabela_editavel(aux)
          handleCancel()

          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print("handleUpdatetabela", error, true);
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
        setIsLoading(false);
      }
  };

  const handleClickOpenDelete = () => {
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
      if (obj_tabela_editavel?.id_mes_tab_dois !== null) {
        setIsLoading(true);

        let res = await del(auth.token.cookie_token, `/delete_mes_tab_dois/${obj_tabela_editavel?.id_mes_tab_dois}`);

        if (res.status === 200) {
          setMessage("Registo eliminado com sucesso!");
          setOpenDelete(false);

          let aux = lista_tabela_editavel.filter((el) => el.id_mes_tab_dois !== obj_tabela_editavel?.id_mes_tab_dois)
          set_obj_tabela_editavel(undefined);
          set_lista_tabela_editavel(aux)
          set_obj_tabela_nao_editavel(res.data.result[0][0])
          set_rows_balanco(res.data.result[1][0])
          handleCancel()
          setCreate(true)

          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao eliminar o registo!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      }
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  const handleClickOpenDelete_mes_completo = async () => {
    try {
      if (obj_tabela_nao_editavel?.id_mes_tab_um !== null) {
        setIsLoading(true);

        let res = await del(auth.token.cookie_token, `/delete_mes_tab_um/${obj_tabela_nao_editavel?.id_mes_tab_um}`);

        if (res.status === 200) {
          setMessage("Registo eliminado com sucesso!");
          setOpenDelete(false);

          let aux = lista_tabela_nao_editavel.filter((el) => el.id_mes_tab_um !== obj_tabela_nao_editavel?.id_mes_tab_um)
          let aux1 = lista_tabela_editavel.filter((el) => el.id_mes_tab_dois !== obj_tabela_editavel?.id_mes_tab_dois)
          set_obj_tabela_editavel(undefined);
          set_obj_tabela_nao_editavel(undefined)
          set_rows_balanco(res.data.result[0])
          set_lista_tabela_editavel(aux1)
          set_lista_tabela_nao_editavel(aux)
          handleCancel()
          setCreate(true)

          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao eliminar o registo!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      }
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }


  useEffect(() => {
    func_reset()
  }, [mes_escolhido, idCabecalho]);



  return (
    <CustomThemeProvider>
      {isLoading ?

        <LoadingVulpes /> :

        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{ height: "auto", width: "auto", padding: 2, margin: 1 }}
        >

          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={() => setOpenSnackSuccess(false)}
          >
            <Alert
              onClose={() => setOpenSnackSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={() => setOpenSnackError(false)}
          >
            <Alert
              onClose={() => setOpenSnackError(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>



          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: "space-between"
          }}>

            <div style={{
              // backgroundColor: 'red',
              display: 'flex',
              flexDirection: "row",
              alignItems: "center"
            }}>
              Eliminar informação do mês de {mes_escolhido}
              <ButtonCadernos

                mostrarBotaoApagar
                aoClicarApagar={() => { handleClickOpenDelete_mes_completo() }} />

            </div>
            {create === true ?
              <ButtonCadernos
                mostrarBotaoGravar
                aoClicarGravar={() => handleSaveTabela()}
              />
              :
              editRow ?
                <ButtonCadernos
                  mostrarBotaoGravar
                  aoClicarGravar={() => { handleUpdatetabela() }}
                  mostrarBotaoCancelar
                  aoClicarCancelar={() => { handleCancel() }} />
                :
                <ButtonCadernos
                  mostrarBotaoEditar
                  aoClicarEditar={() => {
                    setEditRow(true)
                    set_obj_tabela_editar(obj_tabela_editavel)
                  }}
                  mostrarBotaoApagar
                  aoClicarApagar={() => { handleClickOpenDelete() }} />
            }
          </div>


          <Stack direction="row">
            {
              editRow === true || create === true ?
                <TabelaMesResumo
                  tabela={obj_tabela_editar}
                /> :
                <Tabelanaoeditavel
                  tabela={obj_tabela_nao_editavel}
                  tabela_editavel={obj_tabela_editavel}

                />
            }


            <Box sx={{ width: 50 }}></Box>
            <table width="100%">
              <TableHead>
                <TableRow>
                  <StyledTableHead rowSpan={2}>Efetivo pecuário</StyledTableHead>
                  <StyledTableHead rowSpan={2}>Nº de animais</StyledTableHead>
                  <StyledTableHead rowSpan={2}>Nº de dias</StyledTableHead>
                  <StyledTableHead colSpan={4}>
                    Tipo de alimento(kg/MS/dia/animal)
                  </StyledTableHead>
                </TableRow>
                <TableRow>
                  <StyledTableHead>Pastagem</StyledTableHead>
                  <StyledTableHead>Silagem</StyledTableHead>
                  <StyledTableHead>Outra Forragem</StyledTableHead>
                  <StyledTableHead>Composto</StyledTableHead>
                </TableRow>
              </TableHead>
              <TableBody>


                {create || obj_tabela_editar !== undefined ?
                  <>
                    <TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Machos com < 6 meses"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_menor_seis_Num_Animais"
                          value={obj_tabela_editar?.bovinos_M_menor_seis_Num_Animais === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Num_Animais === null ? "" : obj_tabela_editar.bovinos_M_menor_seis_Num_Animais.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_menor_seis_Num_Animais}
                          helperText={error_bovinos_M_menor_seis_Num_Animais ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_menor_seis_Num_Dias"
                          value={obj_tabela_editar?.bovinos_M_menor_seis_Num_Dias === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Num_Dias === null ? "" : obj_tabela_editar.bovinos_M_menor_seis_Num_Dias.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_menor_seis_Num_Dias}
                          helperText={error_bovinos_M_menor_seis_Num_Dias ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_menor_seis_Pastagem"
                          value={obj_tabela_editar?.bovinos_M_menor_seis_Pastagem === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Pastagem === null ? "" : obj_tabela_editar.bovinos_M_menor_seis_Pastagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_menor_seis_Pastagem}
                          helperText={error_bovinos_M_menor_seis_Pastagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_menor_seis_Silagem"
                          value={obj_tabela_editar?.bovinos_M_menor_seis_Silagem === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Silagem === null ? "" : obj_tabela_editar.bovinos_M_menor_seis_Silagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_menor_seis_Silagem}
                          helperText={error_bovinos_M_menor_seis_Silagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_menor_seis_outra_ferragem"
                          value={obj_tabela_editar?.bovinos_M_menor_seis_outra_ferragem === undefined || obj_tabela_editar?.bovinos_M_menor_seis_outra_ferragem === null ? "" : obj_tabela_editar.bovinos_M_menor_seis_outra_ferragem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_menor_seis_outra_ferragem}
                          helperText={error_bovinos_M_menor_seis_outra_ferragem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_menor_seis_Composto"
                          value={obj_tabela_editar?.bovinos_M_menor_seis_Composto === undefined || obj_tabela_editar?.bovinos_M_menor_seis_Composto === null ? "" : obj_tabela_editar.bovinos_M_menor_seis_Composto.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_menor_seis_Composto}
                          helperText={error_bovinos_M_menor_seis_Composto ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>

                    </TableRow>
                    <TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Fêmeas com < 6 meses"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_menor_seis_Num_Animais"
                          value={obj_tabela_editar?.bovinos_F_menor_seis_Num_Animais === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Num_Animais === null ? "" : obj_tabela_editar.bovinos_F_menor_seis_Num_Animais.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_menor_seis_Num_Animais}
                          helperText={error_bovinos_F_menor_seis_Num_Animais ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_menor_seis_Num_Dias"
                          value={obj_tabela_editar?.bovinos_F_menor_seis_Num_Dias === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Num_Dias === null ? "" : obj_tabela_editar.bovinos_F_menor_seis_Num_Dias.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_menor_seis_Num_Dias}
                          helperText={error_bovinos_F_menor_seis_Num_Dias ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_menor_seis_Pastagem"
                          value={obj_tabela_editar?.bovinos_F_menor_seis_Pastagem === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Pastagem === null ? "" : obj_tabela_editar.bovinos_F_menor_seis_Pastagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_menor_seis_Pastagem}
                          helperText={error_bovinos_F_menor_seis_Pastagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_menor_seis_Silagem"
                          value={obj_tabela_editar?.bovinos_F_menor_seis_Silagem === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Silagem === null ? "" : obj_tabela_editar.bovinos_F_menor_seis_Silagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_menor_seis_Silagem}
                          helperText={error_bovinos_F_menor_seis_Silagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_menor_seis_outra_ferragem"
                          value={obj_tabela_editar?.bovinos_F_menor_seis_outra_ferragem === undefined || obj_tabela_editar?.bovinos_F_menor_seis_outra_ferragem === null ? "" : obj_tabela_editar.bovinos_F_menor_seis_outra_ferragem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_menor_seis_outra_ferragem}
                          helperText={error_bovinos_F_menor_seis_outra_ferragem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_menor_seis_Composto"
                          value={obj_tabela_editar?.bovinos_F_menor_seis_Composto === undefined || obj_tabela_editar?.bovinos_F_menor_seis_Composto === null ? "" : obj_tabela_editar.bovinos_F_menor_seis_Composto.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_menor_seis_Composto}
                          helperText={error_bovinos_F_menor_seis_Composto ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Machos de 6 meses a < 1 ano"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_seis_um_Num_Animais"
                          value={obj_tabela_editar?.bovinos_M_seis_um_Num_Animais === undefined || obj_tabela_editar?.bovinos_M_seis_um_Num_Animais === null ? "" : obj_tabela_editar.bovinos_M_seis_um_Num_Animais.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_seis_um_Num_Animais}
                          helperText={error_bovinos_M_seis_um_Num_Animais ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_seis_um_Num_Dias"
                          value={obj_tabela_editar?.bovinos_M_seis_um_Num_Dias === undefined || obj_tabela_editar?.bovinos_M_seis_um_Num_Dias === null ? "" : obj_tabela_editar.bovinos_M_seis_um_Num_Dias.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_seis_um_Num_Dias}
                          helperText={error_bovinos_M_seis_um_Num_Dias ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_seis_um_Pastagem"
                          value={obj_tabela_editar?.bovinos_M_seis_um_Pastagem === undefined || obj_tabela_editar?.bovinos_M_seis_um_Pastagem === null ? "" : obj_tabela_editar.bovinos_M_seis_um_Pastagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_seis_um_Pastagem}
                          helperText={error_bovinos_M_seis_um_Pastagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_seis_um_Silagem"
                          value={obj_tabela_editar?.bovinos_M_seis_um_Silagem === undefined || obj_tabela_editar?.bovinos_M_seis_um_Silagem === null ? "" : obj_tabela_editar.bovinos_M_seis_um_Silagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_seis_um_Silagem}
                          helperText={error_bovinos_M_seis_um_Silagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_seis_um_outra_ferragem"
                          value={obj_tabela_editar?.bovinos_M_seis_um_outra_ferragem === undefined || obj_tabela_editar?.bovinos_M_seis_um_outra_ferragem === null ? "" : obj_tabela_editar.bovinos_M_seis_um_outra_ferragem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_seis_um_outra_ferragem}
                          helperText={error_bovinos_M_seis_um_outra_ferragem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_seis_um_Composto"
                          value={obj_tabela_editar?.bovinos_M_seis_um_Composto === undefined || obj_tabela_editar?.bovinos_M_seis_um_Composto === null ? "" : obj_tabela_editar.bovinos_M_seis_um_Composto.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_seis_um_Composto}
                          helperText={error_bovinos_M_seis_um_Composto ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Fêmeas de 6 meses a < 1 ano"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_seis_um_Num_Animais"
                          value={obj_tabela_editar?.bovinos_F_seis_um_Num_Animais === undefined || obj_tabela_editar?.bovinos_F_seis_um_Num_Animais === null ? "" : obj_tabela_editar.bovinos_F_seis_um_Num_Animais.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_seis_um_Num_Animais}
                          helperText={error_bovinos_F_seis_um_Num_Animais ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_seis_um_Num_Dias"
                          value={obj_tabela_editar?.bovinos_F_seis_um_Num_Dias === undefined || obj_tabela_editar?.bovinos_F_seis_um_Num_Dias === null ? "" : obj_tabela_editar.bovinos_F_seis_um_Num_Dias.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_seis_um_Num_Dias}
                          helperText={error_bovinos_F_seis_um_Num_Dias ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_seis_um_Pastagem"
                          value={obj_tabela_editar?.bovinos_F_seis_um_Pastagem === undefined || obj_tabela_editar?.bovinos_F_seis_um_Pastagem === null ? "" : obj_tabela_editar.bovinos_F_seis_um_Pastagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_seis_um_Pastagem}
                          helperText={error_bovinos_F_seis_um_Pastagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_seis_um_Silagem"
                          value={obj_tabela_editar?.bovinos_F_seis_um_Silagem === undefined || obj_tabela_editar?.bovinos_F_seis_um_Silagem === null ? "" : obj_tabela_editar.bovinos_F_seis_um_Silagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_seis_um_Silagem}
                          helperText={error_bovinos_F_seis_um_Silagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_seis_um_outra_ferragem"
                          value={obj_tabela_editar?.bovinos_F_seis_um_outra_ferragem === undefined || obj_tabela_editar?.bovinos_F_seis_um_outra_ferragem === null ? "" : obj_tabela_editar.bovinos_F_seis_um_outra_ferragem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_seis_um_outra_ferragem}
                          helperText={error_bovinos_F_seis_um_outra_ferragem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_seis_um_Composto"
                          value={obj_tabela_editar?.bovinos_F_seis_um_Composto === undefined || obj_tabela_editar?.bovinos_F_seis_um_Composto === null ? "" : obj_tabela_editar.bovinos_F_seis_um_Composto.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_seis_um_Composto}
                          helperText={error_bovinos_F_seis_um_Composto ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Machos de 1 ano a < 2 anos"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_um_dois_Num_Animais"
                          value={obj_tabela_editar?.bovinos_M_um_dois_Num_Animais === undefined || obj_tabela_editar?.bovinos_M_um_dois_Num_Animais === null ? "" : obj_tabela_editar.bovinos_M_um_dois_Num_Animais.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_um_dois_Num_Animais}
                          helperText={error_bovinos_M_um_dois_Num_Animais ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_um_dois_Num_Dias"
                          value={obj_tabela_editar?.bovinos_M_um_dois_Num_Dias === undefined || obj_tabela_editar?.bovinos_M_um_dois_Num_Dias === null ? "" : obj_tabela_editar.bovinos_M_um_dois_Num_Dias.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_um_dois_Num_Dias}
                          helperText={error_bovinos_M_um_dois_Num_Dias ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_um_dois_Pastagem"
                          value={obj_tabela_editar?.bovinos_M_um_dois_Pastagem === undefined || obj_tabela_editar?.bovinos_M_um_dois_Pastagem === null ? "" : obj_tabela_editar.bovinos_M_um_dois_Pastagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_um_dois_Pastagem}
                          helperText={error_bovinos_M_um_dois_Pastagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_um_dois_Silagem"
                          value={obj_tabela_editar?.bovinos_M_um_dois_Silagem === undefined || obj_tabela_editar?.bovinos_M_um_dois_Silagem === null ? "" : obj_tabela_editar.bovinos_M_um_dois_Silagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_um_dois_Silagem}
                          helperText={error_bovinos_M_um_dois_Silagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_um_dois_outra_ferragem"
                          value={obj_tabela_editar?.bovinos_M_um_dois_outra_ferragem === undefined || obj_tabela_editar?.bovinos_M_um_dois_outra_ferragem === null ? "" : obj_tabela_editar.bovinos_M_um_dois_outra_ferragem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_um_dois_outra_ferragem}
                          helperText={error_bovinos_M_um_dois_outra_ferragem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_um_dois_Composto"
                          value={obj_tabela_editar?.bovinos_M_um_dois_Composto === undefined || obj_tabela_editar?.bovinos_M_um_dois_Composto === null ? "" : obj_tabela_editar.bovinos_M_um_dois_Composto.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_um_dois_Composto}
                          helperText={error_bovinos_M_um_dois_Composto ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Fêmeas de 1 ano a < 2 anos"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_um_dois_Num_Animais"
                          value={obj_tabela_editar?.bovinos_F_um_dois_Num_Animais === undefined || obj_tabela_editar?.bovinos_F_um_dois_Num_Animais === null ? "" : obj_tabela_editar.bovinos_F_um_dois_Num_Animais.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_um_dois_Num_Animais}
                          helperText={error_bovinos_F_um_dois_Num_Animais ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_um_dois_Num_Dias"
                          value={obj_tabela_editar?.bovinos_F_um_dois_Num_Dias === undefined || obj_tabela_editar?.bovinos_F_um_dois_Num_Dias === null ? "" : obj_tabela_editar.bovinos_F_um_dois_Num_Dias.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_um_dois_Num_Dias}
                          helperText={error_bovinos_F_um_dois_Num_Dias ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_um_dois_Pastagem"
                          value={obj_tabela_editar?.bovinos_F_um_dois_Pastagem === undefined || obj_tabela_editar?.bovinos_F_um_dois_Pastagem === null ? "" : obj_tabela_editar.bovinos_F_um_dois_Pastagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_um_dois_Pastagem}
                          helperText={error_bovinos_F_um_dois_Pastagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_um_dois_Silagem"
                          value={obj_tabela_editar?.bovinos_F_um_dois_Silagem === undefined || obj_tabela_editar?.bovinos_F_um_dois_Silagem === null ? "" : obj_tabela_editar.bovinos_F_um_dois_Silagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_um_dois_Silagem}
                          helperText={error_bovinos_F_um_dois_Silagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_um_dois_outra_ferragem"
                          value={obj_tabela_editar?.bovinos_F_um_dois_outra_ferragem === undefined || obj_tabela_editar?.bovinos_F_um_dois_outra_ferragem === null ? "" : obj_tabela_editar.bovinos_F_um_dois_outra_ferragem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_um_dois_outra_ferragem}
                          helperText={error_bovinos_F_um_dois_outra_ferragem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_um_dois_Composto"
                          value={obj_tabela_editar?.bovinos_F_um_dois_Composto === undefined || obj_tabela_editar?.bovinos_F_um_dois_Composto === null ? "" : obj_tabela_editar.bovinos_F_um_dois_Composto.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_um_dois_Composto}
                          helperText={error_bovinos_F_um_dois_Composto ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Machos com ≥ 2 anos"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_maior_dois_Num_Animais"
                          value={obj_tabela_editar?.bovinos_M_maior_dois_Num_Animais === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Num_Animais === null ? "" : obj_tabela_editar.bovinos_M_maior_dois_Num_Animais.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_maior_dois_Num_Animais}
                          helperText={error_bovinos_M_maior_dois_Num_Animais ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_maior_dois_Num_Dias"
                          value={obj_tabela_editar?.bovinos_M_maior_dois_Num_Dias === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Num_Dias === null ? "" : obj_tabela_editar.bovinos_M_maior_dois_Num_Dias.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_maior_dois_Num_Dias}
                          helperText={error_bovinos_M_maior_dois_Num_Dias ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_maior_dois_Pastagem"
                          value={obj_tabela_editar?.bovinos_M_maior_dois_Pastagem === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Pastagem === null ? "" : obj_tabela_editar.bovinos_M_maior_dois_Pastagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_maior_dois_Pastagem}
                          helperText={error_bovinos_M_maior_dois_Pastagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_maior_dois_Silagem"
                          value={obj_tabela_editar?.bovinos_M_maior_dois_Silagem === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Silagem === null ? "" : obj_tabela_editar.bovinos_M_maior_dois_Silagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_maior_dois_Silagem}
                          helperText={error_bovinos_M_maior_dois_Silagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_maior_dois_outra_ferragem"
                          value={obj_tabela_editar?.bovinos_M_maior_dois_outra_ferragem === undefined || obj_tabela_editar?.bovinos_M_maior_dois_outra_ferragem === null ? "" : obj_tabela_editar.bovinos_M_maior_dois_outra_ferragem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_maior_dois_outra_ferragem}
                          helperText={error_bovinos_M_maior_dois_outra_ferragem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_M_maior_dois_Composto"
                          value={obj_tabela_editar?.bovinos_M_maior_dois_Composto === undefined || obj_tabela_editar?.bovinos_M_maior_dois_Composto === null ? "" : obj_tabela_editar.bovinos_M_maior_dois_Composto.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_M_maior_dois_Composto}
                          helperText={error_bovinos_M_maior_dois_Composto ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Fêmeas com ≥ 2 anos"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_maior_dois_Num_Animais"
                          value={obj_tabela_editar?.bovinos_F_maior_dois_Num_Animais === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Num_Animais === null ? "" : obj_tabela_editar.bovinos_F_maior_dois_Num_Animais.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_maior_dois_Num_Animais}
                          helperText={error_bovinos_F_maior_dois_Num_Animais ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_maior_dois_Num_Dias"
                          value={obj_tabela_editar?.bovinos_F_maior_dois_Num_Dias === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Num_Dias === null ? "" : obj_tabela_editar.bovinos_F_maior_dois_Num_Dias.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_maior_dois_Num_Dias}
                          helperText={error_bovinos_F_maior_dois_Num_Dias ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_maior_dois_Pastagem"
                          value={obj_tabela_editar?.bovinos_F_maior_dois_Pastagem === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Pastagem === null ? "" : obj_tabela_editar.bovinos_F_maior_dois_Pastagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_maior_dois_Pastagem}
                          helperText={error_bovinos_F_maior_dois_Pastagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_maior_dois_Silagem"
                          value={obj_tabela_editar?.bovinos_F_maior_dois_Silagem === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Silagem === null ? "" : obj_tabela_editar.bovinos_F_maior_dois_Silagem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_maior_dois_Silagem}
                          helperText={error_bovinos_F_maior_dois_Silagem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_maior_dois_outra_ferragem"
                          value={obj_tabela_editar?.bovinos_F_maior_dois_outra_ferragem === undefined || obj_tabela_editar?.bovinos_F_maior_dois_outra_ferragem === null ? "" : obj_tabela_editar.bovinos_F_maior_dois_outra_ferragem.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_maior_dois_outra_ferragem}
                          helperText={error_bovinos_F_maior_dois_outra_ferragem ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="bovinos_F_maior_dois_Composto"
                          value={obj_tabela_editar?.bovinos_F_maior_dois_Composto === undefined || obj_tabela_editar?.bovinos_F_maior_dois_Composto === null ? "" : obj_tabela_editar.bovinos_F_maior_dois_Composto.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_bovinos_F_maior_dois_Composto}
                          helperText={error_bovinos_F_maior_dois_Composto ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                    </TableRow>
                  </>
                  :
                  <>
                    <TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Machos com < 6 meses"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_menor_seis_Num_Animais === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_menor_seis_Num_Animais)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_menor_seis_Num_Dias === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_menor_seis_Num_Dias)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_menor_seis_Pastagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_menor_seis_Pastagem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_menor_seis_Silagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_menor_seis_Silagem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_menor_seis_outra_ferragem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_menor_seis_outra_ferragem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_menor_seis_Composto === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_menor_seis_Composto)} </StyledTableCell>

                    </TableRow><TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Fêmeas com < 6 meses"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_menor_seis_Num_Animais === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_menor_seis_Num_Animais)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_menor_seis_Num_Dias === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_menor_seis_Num_Dias)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_menor_seis_Pastagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_menor_seis_Pastagem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_menor_seis_Silagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_menor_seis_Silagem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_menor_seis_outra_ferragem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_menor_seis_outra_ferragem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_menor_seis_Composto === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_menor_seis_Composto)}</StyledTableCell>
                    </TableRow><TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Machos de 6 meses a < 1 ano"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_seis_um_Num_Animais === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_seis_um_Num_Animais)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_seis_um_Num_Dias === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_seis_um_Num_Dias)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_seis_um_Pastagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_seis_um_Pastagem)}</StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_seis_um_Silagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_seis_um_Silagem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_seis_um_outra_ferragem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_seis_um_outra_ferragem)}</StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_seis_um_Composto === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_seis_um_Composto)}</StyledTableCell>
                    </TableRow><TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Fêmeas de 6 meses a < 1 ano"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_seis_um_Num_Animais === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_seis_um_Num_Animais)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_seis_um_Num_Dias === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_seis_um_Num_Dias)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_seis_um_Pastagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_seis_um_Pastagem)}</StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_seis_um_Silagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_seis_um_Silagem)}</StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_seis_um_outra_ferragem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_seis_um_outra_ferragem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_seis_um_Composto === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_seis_um_Composto)} </StyledTableCell>
                    </TableRow><TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Machos de 1 ano a < 2 anos"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_um_dois_Num_Animais === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_um_dois_Num_Animais)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_um_dois_Num_Dias === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_um_dois_Num_Dias)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_um_dois_Pastagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_um_dois_Pastagem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_um_dois_Silagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_um_dois_Silagem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_um_dois_outra_ferragem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_um_dois_outra_ferragem)}</StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_um_dois_Composto === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_um_dois_Composto)}</StyledTableCell>
                    </TableRow><TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Fêmeas de 1 ano a < 2 anos"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_um_dois_Num_Animais === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_um_dois_Num_Animais)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_um_dois_Num_Dias === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_um_dois_Num_Dias)}</StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_um_dois_Pastagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_um_dois_Pastagem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_um_dois_Silagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_um_dois_Silagem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_um_dois_outra_ferragem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_um_dois_outra_ferragem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_um_dois_Composto === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_um_dois_Composto)}</StyledTableCell>
                    </TableRow><TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Machos com ≥ 2 anos"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_maior_dois_Num_Animais === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_maior_dois_Num_Animais)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_maior_dois_Num_Dias === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_maior_dois_Num_Dias)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_maior_dois_Pastagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_maior_dois_Pastagem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_maior_dois_Silagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_maior_dois_Silagem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_maior_dois_outra_ferragem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_maior_dois_outra_ferragem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_M_maior_dois_Composto === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_M_maior_dois_Composto)} </StyledTableCell>
                    </TableRow><TableRow>
                      <StyledTableHeadLeft>
                        {"Bovinos Fêmeas com ≥ 2 anos"}
                      </StyledTableHeadLeft>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_maior_dois_Num_Animais === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_maior_dois_Num_Animais)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_maior_dois_Num_Dias === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_maior_dois_Num_Dias)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_maior_dois_Pastagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_maior_dois_Pastagem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_maior_dois_Silagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_maior_dois_Silagem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_maior_dois_outra_ferragem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_maior_dois_outra_ferragem)} </StyledTableCell>
                      <StyledTableCell>{obj_tabela_editavel?.bovinos_F_maior_dois_Composto === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editavel?.bovinos_F_maior_dois_Composto)} </StyledTableCell>
                    </TableRow>
                  </>
                }
              </TableBody>


            </table>
          </Stack>
        </TableContainer>
      }
      <ConfirmDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={handleDelete}
        message="Deseja eliminar o registo?"
      />
    </CustomThemeProvider >

  );
};
